export interface Image {
  tag: ImageTag;
  blob?: Blob;
  url?: string;
}


export enum ImageTag {
  OVERALL = 'OVERALL',
  NOSE = 'NOSE',
  TAIL = 'TAIL',
  EOD = 'EOD',
}
